import { forwardRef } from "react";
import DatePicker from "react-datepicker";
// package styling
import "react-datepicker/dist/react-datepicker.css";
// styles
import { TimePickerStyles } from "./timePicker.styles";

const CustomTimePicker = ({
  value,
  name,
  touched,
  error,
  dateFormat = "hh:mm aa",
  handleChange,
  placeholderText
}) => {
  const CustomInput = forwardRef(({ value, onClick, placeholderText }, ref) => (
    <div className={`input ${value && "selected"}`} onClick={onClick} ref={ref}>
      <div className="valueContainer">
        {value ? (
          <span className="value">{value}</span>
        ) : (
          <span className="placeholder">{placeholderText}</span>
        )}
      </div>
    </div>
  ));
  return (
    <TimePickerStyles>
      <DatePicker
        className="timePicker"
        selected={value}
        onChange={date => handleChange(date)}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        timeCaption="Time"
        customInput={
          <CustomInput placeholderText={placeholderText || "Select time"} />
        }
        dateFormat={dateFormat}
        popperProps={{ strategy: "fixed" }}
      />
      <p className="errorMessage">{touched && error && error}</p>
    </TimePickerStyles>
  );
};

export default CustomTimePicker;
